<template>
    <div class="flex-row date-config">
        <el-form-item :label="$t.__('pages.account.sale.DateConfig.context')" class="pr-4">
            <el-select v-model="context" class="cart-config-context">
                <el-option
                    value="new"
                    :disabled="isGold"
                    :label="$t.__('pages.account.sale.DateConfig.new')"
                ></el-option>
                <el-option
                    value="upsale"
                    :disabled="isTrial || renewOnOlderPricingVersion"
                    :label="$t.__('pages.account.sale.DateConfig.evolution')"
                ></el-option>
                <el-option
                    value="renew"
                    :disabled="isTrial"
                    :label="$t.__('common.labels.renewal')"
                ></el-option>
                <el-option
                    value="earlyRenew"
                    :disabled="isTrial"
                    :label="$t.__('pages.account.sale.DateConfig.early_renewal')"
                ></el-option>
            </el-select>
        </el-form-item>

        <!-- Activation Date for New Cart -->
        <el-form-item
            ref="activation-date-item"
            v-if="isNew"
            :label="$t.__('pages.account.sale.DateConfig.activation_date')"
            class="pr-4"
        >
            <date-input
                mode="edit"
                v-model="activationDate"
                :options="activationDateOptions"
                :placeholder="$t.__('pages.account.sale.DateConfig.date_format')"
            >
            </date-input>
        </el-form-item>

        <!-- EarlyRenewDate -->
        <el-form-item
            ref="early-activation-date-item"
            v-if="isRenew"
            :label="$t.__('pages.account.sale.DateConfig.activation_date')"
            class="pr-4"
        >
            <date-input
                mode="edit"
                v-model="earlyRenewDate"
                :options="activationDateOptions"
                disabled
                :placeholder="$t.__('pages.account.sale.DateConfig.date_format')"
            >
            </date-input>
        </el-form-item>

        <!-- Expiration Date -->
        <el-form-item
            ref="expiration-date-item"
            :label="$t.__('pages.account.sale.DateConfig.offer_expiration_date')"
        >
            <date-input
                mode="edit"
                v-model="expireDate"
                :options="expirationDateOptions"
                :placeholder="$t.__('pages.account.sale.DateConfig.date_format')"
            >
            </date-input>
        </el-form-item>
    </div>
</template>

<script>
import DateInput from 'vcomponents/inputs/DateInput.vue';

export default {
    props: {
        store: {
            type: String,
            required: true,
        },
    },
    data() {
        return {
            baseOptions: {
                disabledDate(time) {
                    return time.getTime() > Date.now();
                },
            },
        };
    },
    computed: {
        context: {
            get() {
                const context = this.$store.getters[`${this.store}Cart/context`];
                return this.isEarlyRenew ? 'earlyRenew' : context;
            },
            set(value) {
                if (value === this.context) return;

                if (value === 'earlyRenew') {
                    this.earlyRenewDate = null;
                }

                let route;
                let params = {
                    id: 'new',
                    thirdId: this.$route.params.thirdId,
                    customerId: this.$route.params.customerId,
                };
                let query = {};

                switch (value) {
                    case 'new':
                        route = 'sam.v4.cart.form';
                        break;
                    case 'upsale':
                        params.corpId = this.$route.params.corpId;
                        route = 'sam.v4.upsell.cart.form';
                        break;
                    case 'renew':
                        params.corpId = this.$route.params.corpId;
                        route = 'sam.v4.sale.renew.cart.form';
                        break;
                    case 'earlyRenew':
                        params.corpId = this.$route.params.corpId;
                        query.early = 'true';
                        route = 'sam.v4.sale.renew.cart.form';
                        break;
                    default:
                        break;
                }

                this.$router.push({ name: route, params, query });
            },
        },
        activationDate: {
            get() {
                return this.$store.getters[`${this.store}Cart/periodApplianceStart`];
            },
            set(value) {
                this.$store.commit(`${this.store}Cart/setPeriodApplianceStart`, value);
            },
        },
        earlyRenewDate: {
            get() {
                return this.$store.getters[`${this.store}Cart/earlyRenewDate`];
            },
            set(value) {
                this.$store.commit(`${this.store}Cart/setEarlyRenewDate`, value);
            },
        },
        expireDate: {
            get() {
                return this.$store.getters[`${this.store}Cart/expirationDate`];
            },
            set(value) {
                this.$store.commit(`${this.store}Cart/setExpirationDate`, value);
            },
        },
        activationDateOptions() {
            return {
                ...this.baseOptions,
                disabledDate: (time) => {
                    return time.getTime() < Date.now();
                },
            };
        },
        expirationDateOptions() {
            return {
                ...this.baseOptions,
                disabledDate: this.isRenew
                    ? this.expirationRenewDateOptions
                    : (time) => {
                          return (
                              time.getTime() < Date.now() ||
                              time.getTime() < Date.parse(this.activationDate)
                          );
                      },
            };
        },
        expirationRenewDateOptions() {
            return (time) => {
                return (
                    time.getTime() < Date.now() ||
                    time.getTime() > this.expireDateRenewTime ||
                    time.getTime() < Date.parse(this.renewDateOptions)
                );
            };
        },
        expireDateRenewTime() {
            return moment(
                !this.isNew
                    ? this.$store.getters[`${this.store}Cart/previousCart`].serviceEndDate
                    : '',
            ).valueOf();
        },
        isGold() {
            return this.$store.getters[`${this.store}Cart/isGold`];
        },
        isTrial() {
            return this.$store.getters[`${this.store}Cart/isTrial`];
        },
        isNew() {
            return this.$store.getters[`${this.store}Cart/isNew`];
        },
        isUpsell() {
            return this.$store.getters[`${this.store}Cart/isUpsell`];
        },
        isRenew() {
            return this.$store.getters[`${this.store}Cart/isRenew`];
        },
        isEarlyRenew() {
            return this.$store.getters[`${this.store}Cart/earlyRenewal`];
        },
        renewOnOlderPricingVersion() {
            return this.$store.getters[`${this.store}Cart/renewOnOlderPricingVersion`];
        },
    },
    components: {
        DateInput,
    },
};
</script>

<style lang="scss" scoped>
.date-config {
    margin-bottom: 80px;
}
</style>
